export default (body: object) =>
  Object.keys(body).some(key => key === 'passId');
